import { token } from '@/styled-system/tokens'

export const COLORS = {
  green: { default: '#086D59', lighten: '#16856F' },
  red: {
    default: token.var('colors.red.500'),
    lighten: token.var('colors.red.400'),
  },
  black: {
    default: token.var('colors.neutral.300'),
    lighten: token.var('colors.neutral.500'),
  },
  none: { default: '', lighten: '' },
}

export const NUMBER_SEQUENCE = [
  0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24,
  16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
]

export const NUMBER_COLORS: ('green' | 'red' | 'black')[] = [
  'green',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
  'black',
  'red',
]

export const POCKETS = [
  { id: 'number0', label: '0', color: 'green', numberValue: 0 },
  { id: 'number1', label: '1', color: 'red', numberValue: 1 },
  { id: 'number2', label: '2', color: 'black', numberValue: 2 },
  { id: 'number3', label: '3', color: 'red', numberValue: 3 },
  { id: 'number4', label: '4', color: 'black', numberValue: 4 },
  { id: 'number5', label: '5', color: 'red', numberValue: 5 },
  { id: 'number6', label: '6', color: 'black', numberValue: 6 },
  { id: 'number7', label: '7', color: 'red', numberValue: 7 },
  { id: 'number8', label: '8', color: 'black', numberValue: 8 },
  { id: 'number9', label: '9', color: 'red', numberValue: 9 },
  { id: 'number10', label: '10', color: 'black', numberValue: 10 },
  { id: 'number11', label: '11', color: 'black', numberValue: 11 },
  { id: 'number12', label: '12', color: 'red', numberValue: 12 },
  { id: 'number13', label: '13', color: 'black', numberValue: 13 },
  { id: 'number14', label: '14', color: 'red', numberValue: 14 },
  { id: 'number15', label: '15', color: 'black', numberValue: 15 },
  { id: 'number16', label: '16', color: 'red', numberValue: 16 },
  { id: 'number17', label: '17', color: 'black', numberValue: 17 },
  { id: 'number18', label: '18', color: 'red', numberValue: 18 },
  { id: 'number19', label: '19', color: 'red', numberValue: 19 },
  { id: 'number20', label: '20', color: 'black', numberValue: 20 },
  { id: 'number21', label: '21', color: 'red', numberValue: 21 },
  { id: 'number22', label: '22', color: 'black', numberValue: 22 },
  { id: 'number23', label: '23', color: 'red', numberValue: 23 },
  { id: 'number24', label: '24', color: 'black', numberValue: 24 },
  { id: 'number25', label: '25', color: 'red', numberValue: 25 },
  { id: 'number26', label: '26', color: 'black', numberValue: 26 },
  { id: 'number27', label: '27', color: 'red', numberValue: 27 },
  { id: 'number28', label: '28', color: 'black', numberValue: 28 },
  { id: 'number29', label: '29', color: 'black', numberValue: 29 },
  { id: 'number30', label: '30', color: 'red', numberValue: 30 },
  { id: 'number31', label: '31', color: 'black', numberValue: 31 },
  { id: 'number32', label: '32', color: 'red', numberValue: 32 },
  { id: 'number33', label: '33', color: 'black', numberValue: 33 },
  { id: 'number34', label: '34', color: 'red', numberValue: 34 },
  { id: 'number35', label: '35', color: 'black', numberValue: 35 },
  { id: 'number36', label: '36', color: 'red', numberValue: 36 },
  {
    id: 'range0112',
    label: '1 to 12',
    color: 'outlined',
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    id: 'range1324',
    label: '13 to  24',
    color: 'outlined',
    numbers: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  },
  {
    id: 'range2536',
    label: '25 to 36',
    color: 'outlined',
    numbers: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    id: 'range0118',
    label: '1 to 18',
    color: 'outlined',
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  },
  {
    id: 'range1936',
    label: '19 to 36',
    color: 'outlined',
    numbers: [
      19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    ],
  },
  {
    id: 'parityEven',
    label: 'Even',
    color: 'outlined',
    numbers: [
      2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36,
    ],
  },
  {
    id: 'parityOdd',
    label: 'Odd',
    color: 'outlined',
    numbers: [
      1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35,
    ],
  },
  {
    id: 'red',
    label: '',
    color: 'red',
    numbers: [
      1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
    ],
  },
  {
    id: 'black',
    label: '',
    color: 'black',
    numbers: [
      2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35,
    ],
  },
  {
    id: 'row1',
    label: '2:1',
    color: 'outlined',
    numbers: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  },
  {
    id: 'row2',
    label: '2:1',
    color: 'outlined',
    numbers: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  },
  {
    id: 'row3',
    label: '2:1',
    color: 'outlined',
    numbers: [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
  },
] as {
  id: string
  label: string
  numberValue?: number
  color: 'green' | 'red' | 'black' | 'outlined'
  numbers?: number[]
}[]

export const BALL_RADIUS = 12
